import { useUserContext } from '@/UserContext'
import { cn } from '@/utlis/cn'
import { Popover } from 'radix-ui'
import BoostIcon from '@/CustomIcons/BoostIcon'
import { Button } from '@/UIComponents2/Button'
import ElectronIPC from '@/services/ElectronIPC'
import { AccentBadge, AccentBadgeNumber } from './AccentBadge'
import '@/components/popover-animation.css'

type BoostPopoverProps = {
    children?: React.ReactNode
    className?: string
}
export const BoostPopover = (props: BoostPopoverProps) => {
    const [userState] = useUserContext()

    const hasVerifiedEmail = !!userState.profile?.emailVerified

    const style = 'w-[320px] p-4 bg-white/5 z-30'
    const border = 'border-1 border-white/10 rounded-[20px]'
    const bg = "bg-[url('/images/small-top-rings.webp')] bg-no-repeat bg-[#3A3A3A]"
    return (
        <Popover.Root modal={false}>
            <Popover.Trigger className={props.className} asChild>
                {props.children}
            </Popover.Trigger>
            <Popover.Content
                sideOffset={5}
                collisionPadding={18}
                className={cn('popover-content', style, border, bg)}
                style={{ backgroundPosition: 'center -20px' }}
            >
                <div className="flex items-center gap-3">
                    <BoostIcon />
                    <span className="font-medium">Boosts</span>
                </div>
                <div className="flex flex-col gap-4 max-h-[70vh] pt-4">
                    <BoostBadge
                        boostsRemaining={userState.profile?.boostsRemaining ?? 0}
                        boostsMax={userState.profile?.boostsMax ?? 2}
                    />
                    <div className="text-[15px] font-extralight text-center">
                        Boosts give you access to <span className="font-medium">Pro Features</span> for free
                    </div>
                    {!hasVerifiedEmail && (
                        <div className="text-[15px] font-extralight text-center">
                            You must{' '}
                            <Button
                                onClick={() => {
                                    /* OPEN USER PROFILE */
                                }}
                                className="font-medium text-muse-yellow hover:underline"
                            >
                                verify your email
                            </Button>{' '}
                            to use boosts!
                        </div>
                    )}
                    <Button
                        variant="glow"
                        className="w-full p-2"
                        onClick={() => ElectronIPC.openLinkInBrowser('https://musesessions.co/plans#boosts')}
                    >
                        Details
                    </Button>
                </div>
            </Popover.Content>
        </Popover.Root>
    )
}

type BoostBadgeProps = {
    boostsRemaining: number
    boostsMax: number
}
function BoostBadge(props: BoostBadgeProps) {
    return (
        <AccentBadge subText={`/ ${props.boostsMax} per month`}>
            <AccentBadgeNumber>
                <span>{String(props.boostsRemaining).padStart(2, '0')}</span>
                <BoostIcon className="absolute top-[13px] right-[-15px]" style={{ fontSize: '16px' }} />
            </AccentBadgeNumber>
        </AccentBadge>
    )
}
